if (!window.SizeGuide) {
  class SizeGuide extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log("SizeGuide connected");

      // modal 基本元素
      this.trigger = this.querySelector('.size-guide-trigger');
      this.overlay = this.querySelector('.size-guide-modal-overlay');
      this.closeBtn = this.querySelector('.size-guide-close');
      this.backdrop = this.querySelector('.size-guide-backdrop');

      // modal 事件
      this.trigger?.addEventListener('click', () => this.showModal());
      this.closeBtn?.addEventListener('click', () => this.hideModal());
      this.backdrop?.addEventListener('click', () => this.hideModal());
      this.overlay?.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.hideModal();
      });

      // size 切换按钮
      this.buttons = this.querySelectorAll('.button');
      this.buttons.forEach(button => {
        button.addEventListener('click', () => {
          const sizeButton = button.closest('.size-button');
          const sizeBox = sizeButton.closest('.size-box');
          this.toggleUnitDisplay(button, sizeBox);
        });
      });
    }

    // modal 方法
    showModal() {
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    hideModal() {
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    // 单位切换逻辑
    toggleUnitDisplay(button, sizeBox) {
      const checkbox = button.querySelector('.checkbox');
      checkbox.checked = !checkbox.checked;

      if (checkbox.checked) {
        this.showUnit(sizeBox, 'cm');
      } else {
        this.showUnit(sizeBox, 'in');
      }

      // 互斥逻辑：同一个 sizeBox 里只有一个按钮可以选中
      const otherButtons = sizeBox.querySelectorAll('.button');
      otherButtons.forEach(otherButton => {
        if (otherButton !== button && checkbox.checked) {
          const otherCheckbox = otherButton.querySelector('.checkbox');
          otherCheckbox.checked = false;
          this.showUnit(sizeBox, 'in');
        }
      });
    }

    showUnit(sizeBox, unit) {
      const paragraphs = sizeBox.querySelectorAll('p');

      // 先隐藏除第一个外的所有段落
      paragraphs.forEach((p, index) => {
        if (index !== 0) p.style.display = 'none';
      });

      // 显示对应单位
      if (unit === 'in') {
        if (paragraphs[1]) paragraphs[1].style.display = 'block';
      } else {
        if (paragraphs[2]) paragraphs[2].style.display = 'block';
      }
    }
  }

  // 注册组件
  window.SizeGuide = SizeGuide;
  if (!customElements.get('size-guide')) {
    customElements.define('size-guide', SizeGuide);
  }
}
